<!---互动游戏-->
<template>
  <div class="overall_specialIcons">
    <div class="specialIcons-wrap" :class="cls">
      <template v-if="isWeixinOrAutoHomeOrICS && !isSHowSmartGuide">
        <div
          class="specialIcons-item"
          v-for="item in dealerActList"
          :key="item.activityId"
          v-stat:show="{ action: getActShowActionName(item.activityType), extend: {channelId} }"
          v-stat:click="{ action: getActClickActionName(item.activityType), extend: {channelId}  }"
          @click="openDealerAct(item.activityId, item.activityType)"
        >
          <img :src="item.iconImgUrl" />
        </div>
      </template>
      <div
        class="specialIcons-item"
        v-if="hasRedPacket && icsShowState && !isSHowSmartGuide"
        v-stat:show="{ action: 'arhall_findhongbao_show' }"
        v-stat:click="{
          action: 'arhall_findhongbao_click',
          extend: { packid: intendRedPacket.promotionId },
        }"
        @click="openRedPacketPage"
        >
        <img src="@/assets/img/redpacket.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as queryValue from '../services/query.const';
import utils from '../utils/util';
import activityService from '../services/dealerAct.service';
import layerManager from '../services/layer.manager';
import RedPacketService from '../services/redPacket.service';
import * as layerNames from '../services/layerName';
import redPacketsProxy from '../services/actionSync/red.packet.proxy';
export default {
  data () {
    return {
      opened: true,
      realtimeanswer: this.$queryParams.realtimeanswer
    };
  },
  props: {
    isSHowSmartGuide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('intended', {
      hasRedPacket: 'hasRedPacket',
      intendRedPacket: 'intendRedPacket'
    }),
    ...mapGetters({
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      icsShowState: 'busiIcsApp/icsShowState',
      functionData: 'functionData',
      vrSalesInfo: 'sales/vrSalesInfo'
    }),
    ...mapGetters('sales', { salesInfo: 'salesInfo' }),
    dealerActList () {
      return this.functionData.gameList;
    },
    isWeixinOrAutoHomeOrICS () {
      return utils.browser.isWechat || utils.browser.isApp || utils.isICSApp();
    },
    cls () {
      if (this.$queryParams.from === queryValue.QUERY_FROM_GDXIAOCHENGXU) {
        return 'fn-hide';
      }
      if (
        (this.hasActivity && this.showVR === 1 && this.activitySeriesList.length > 0)

        || (this.isWeixinOrAutoHomeOrICS && (this.dealerActList.length > 0))
        || (this.hasRedPacket && this.icsShowState)
      ) {
        return this.opened ? 'overall_specialIcons-on overall_specialIcons-more' : '';
      }
      return 'fn-hide';
    },
    iconUrl () {
      if (this.hasActivity) {
        if (this.showVR === 1) {
          if (this.showCoupon === 0) {
            return '//x.autoimg.cn/dealer/vr/Resources/img/icon-prize.png';
          }
          if (this.showCoupon === 1 || this.showCoupon === 2) {
            return '//x.autoimg.cn/dealer/vr/Resources/img/icon-coupon.png';
          }
        }
      }
      return '';
    },
    salesId: function () {
      return this.salesInfo.salesId;
    },
    dealerId () {
      return this.baseInfo.dealerId;
    },
    isActivity () {
      return this.iconUrl && !this.phoneCallStatus && this.icsShowState;
    },
    channelId () {
      return this.vrSalesInfo.channelId;
    },
  },
  created () {
    new RedPacketService(this.baseInfo)
      .bindRedpacket();
  },
  methods: {
    toggle () {
      if (this.opening) {
        return;
      }
      this.opening = true;
      this.opened = !this.opened;
      setTimeout(() => {
        this.opening = false;
      }, 400);
    },
    getActShowActionName (activityType) {
      return activityService.getActShowActionName(activityType);
    },
    getActClickActionName (activityType) {
      return activityService.getActClickActionName(activityType);
    },
    openDealerAct (activityId, activityType) {
      layerManager.openDealerAct(activityId, activityType, this.salesId);
    },
    openRedPacketPage () {
      redPacketsProxy.order({ isRemote: true });
      const seriesId= this.intendRedPacket && this.intendRedPacket.seriesId || 0;
      const elementId = this.phoneCallStatus ? '2|1211004|897|24487|205349|304290':'2|1211004|897|18491|205073|303809';
      layerManager.open(layerNames.RED_PACKET_FORM_LAYER,
        {
          propsData: {
            dealerId: this.dealerId,
            promotionId: this.intendRedPacket.promotionId,
            redPacketsTypeId: this.intendRedPacket.typeId,
            seriesId: seriesId,
            elementId: elementId
          }
        });
    }
  }
};
</script>

<style lang="scss">
.overall_specialIcons {
  position: absolute;
  right: ptrd(20);
  top: ptrd(100);
  font-size: 0;
  z-index: 2;
  max-width: ptrd(400);
  padding: ptrd(4) ptrd(4) ptrd(4) ptrd(4);
  background: none;
  border: none;
  border-radius: 0;
  .specialIcons-wrap {
    width: 100%;
  }
}
.specialIcons-item {
  height: ptrd(90);
  margin-bottom: ptrd(20);
  position: relative;
  text-align: center;
  vertical-align: middle;
  p {
    position: relative;
    z-index: 10;
    height: ptrd(30);
    line-height: ptrd(30);
    margin: ptrd(-30) 0 0 0;
    padding: 0 ptrd(16);
    text-align: center;
    white-space: nowrap;
    span {
      position: relative;
      display: inline-block;
      vertical-align: top;
      height: ptrd(28);
      line-height: ptrd(28);
      font-size: ptrd(20);
      font-weight: bold;
      text-align: center;
      color: #fff;
      padding: 0 ptrd(4);
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAkCAMAAACUnRs9AAAAP1BMVEVvQ+3bYvvCWfh9RvB1RO7/7rDXYfvTX/rPXvrKXPm3VveuU/WmUfXgb/ScTvOUTPKMSvKGSfB6St7/kjj/kDZ8OMvgAAAAOklEQVQI14XCBw0AIBAAsWPvjX+t5BXQFOdkayglvScEYiQltJY5Uwq10jtjMCdrYYy0Vn7tzTnc+wBhRwHDL9StfgAAAABJRU5ErkJggg==")
      repeat-x;
      background-size: ptrd(2) ptrd(28px);

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: ptrd(-12);
        width: ptrd(14);
        height: ptrd(28);
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAADi0lEQVQ4T4WUXWhURxTH/3PvXbWmFbMpJiTR+mANJMVKCpVuXKgotqs0gqWJ2lbwoRIKxceC0rcKPvShUEigLT5VhYiRiJXQoqGGSo1GCUuo30nMbpLtbkyym+zej5k5ZebeTTYxpQuHexfu7/zOzJk5DP/zo3R3NUzajhAisHgjgK1glGf/xdHMuXJgTQtMcQRgUZ4uY25qHcTsGhBnuRVBmup8Dxadgmfst0cqMDdYC+d5ObwXa8HnVgPSSL0E0uSFVqwSZ3jmtc0zN+uQvb8RYnYtJAHMlGAmqSKXgpT8pRWWaLdHN4QzvzZi/skGQKW2uH4qhDRXAtLY2R0IyU57uGrTZFcEdrIcCAmQISElfJCgzWABSGM/h2Hwczyz7sNk5y7MD1cBIU8b1Ic6QAtGAvNLpaftbSB0pHqakLm1DWRyCEZQIkmkQaFhZQ3WSPHvK/GK7CqM1EZGL8bgZMsgLU9/yAObKMJBIr1GGvouBlN0T/TsDk3eboQ0OTiRDh9W775Z/Vfhg/HT33oz608NdzdjeqwW0nLBJcFTQdDBpQRHUO4COPjNtezjutjTno+QnysDB4cryQ8N+klKyyZtHPh6KD34bv2j35vhSgmXpH46EnCCMj0ptblYqg/2n0iM39lV8/f1A+CWDUcSbGUTpEFXG/2NEpAQpBuRYvRnWyIxsKcm3vsxPLOgoSKsE+gyCaJkjb7xjy+GkvFo/b3eFhRUiaSMUidQodaobdpI/inS4G/HrqVH347d7v0M07lX4TAPhRKrsinYPz2lB+Dq0dOFXMXJvuvHMTq+BZ5RWACLm6NgfYIU6F/gFKPLn8ZgeN39tz4PDcT3woYLh4TeVb0xuvE+pI/nQh/PH67E6kJXaqI+crX3K6RzYXCjEPRx8QQFpkWjznKhuY1gdNzsP4q+of3gsOFB9dS3KcvKYOcnYfDs+Wyu6oOuvhN4OF4PmHm/6eo6BVQRXnqRz+7dAcu7mEy9tfHSX19i5MVmMMOGZHKJMVjqstHx0+5WmF57It0QvnLvGB7+06CbbxkuwEp8y2eOXu+P7x+CYZ+ZzVW/cePBQdx9HsV0/nUIMFiGB5PJxdGxfLZSR7QJpnMSPLTvWaYB9xM7MTJVh6l8JXLOekhpvTwei0mofWc5yG2BwY9AIjozX8Mmspswa1eAy9DKA7m0AvqhqRqSb4fhRcD4OzDEm2DI/wtdnoIFMnCDJQAAAABJRU5ErkJggg==)
        no-repeat 0 0;
        background-size: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: ptrd(-12);
        width: ptrd(14);
        height: ptrd(28);
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAD2UlEQVQ4T32Vf2iVVRjHP895f917tzvncrvDTeePdC21aWH0hxUzhws1bVsFm2RFfzjNIiKqv/wr+zeKhCQIbEgDCSxyYmmTtUWjFqOxflFpeOmKjDuv0+l9731PnPfd5lLxwMs5L5zP+X6f533O84qeOvozWioJJMBXp9H0oNSolD/xN3cYcun4jzk7eT3pVE7iVF8GO4CCGkarw1i6W8pax2/Hyx+7ihkrkU/Z86/i1uQoXZMmsfICEvchr06g5YBUPdV/Myy/P1/I6EBSuqAQwC65TqL+AvObfsFbMm7U02j9pqQ6uufCMvacnwFSSkBrkKKFLgqx6hwLWkYobTwLgeQIpEtqdh6ZgWVkVz4jmpRSgAEFRAv4Ns68Kaq3DVG69k8oWudBtcuiZ783sPywM58RdMoAxmw4h2ugYONVTLKwvY/43WnIO72ofKfU7cnKtx3XMhJalVlAKcECLGM/71Be/w8LW09hJa9AwdkrK3YflK+emcqoOaAlEgKzj7bCde3Wbyh/YBQK1iB+0CrH2q9mlJCKNkZKthLs6XfbOCk6lC87y9KnjyFO3qegtsuRJ69EigpsA4ngKMERwjk8IHBIlE2yfMcxEovPmcS9LYe2Xc5YEsVoNjlzQM8coMDBwnU0Sx4+TdWDg+A7vfLultys1VDFHKAEV4SYAjdcK+zApW79IHUbvwDfHZN3Hr8UWjUxhjbFbCbcbBQ9BZ6lsP0YdY1DrGz5FHwvLfs3T9xIznSMRiVmIBE8K1rbfpzl931Hw+ZuyHtpeas5G4ImxlCVKClGLSZC3FhVCk+7NKzr455Heww4Jq9vGs+AhLUagSZGpkEVxumJQ4kTcP9Dn7Ns7UljtVdeDUFSpsTCzN5k19h0tcddyQmaNh2iovo3CNwD8spj42HJmTtlYFMERjWyCzFRuDrGikWjNDe/h3Ku+Wh3u7w8A5qKD1WjynGIkuOIHcbZsuFj6utPQdEeoGC3haCxaiAzolgNYL6fuZ8lrF48zJZHPiAWz0LR3S0dn314C2jgCAQJYlSXXaRtw/vULhyBQqwXFXRK55fZWTC8nDOPCLoQZ0FJlh3rP2LV0j4I7DTabpMXjkcXecZqZFQoFh3QNjXzzrN13WHW1PVDoHKguuTFr2+0jn0bs5lAq1QhsNEo5nkT3Fv9E5sajlJb+atpGf8SqDek68wn/2tWe5tymYSbS1XEL1JT/heNtQOsSg1juVdAOycJrAOyp//MLe1x4LX9uaR3KZkqTVOVPAe2b1IeNWTR3fLS0O0bsj64evoXYAcE9mnE6kGCUdk3dMdfwH8ucz89AE4MVQAAAABJRU5ErkJggg==)
        no-repeat center center;
        background-size: 100%;
      }
    }
  }
  img {
    width: ptrd(90px);
    height: 100%;
  }
}
.specialIcons-switch {
  position: absolute;
  right: 0;
  width: ptrd(36);
  top: 0;
  height: 100%;
  display: none;
}

.overall_icons {
  position: absolute;
  right: ptrd(10);
  top: 50%;
  width: ptrd(12);
  height: ptrd(20);
  transform: translateY(-50%);
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAC6ADAAQAAAABAAAAFAAAAABjDlpVAAAArklEQVQoFY2TMQ6CQBRE0YJEI3fgBlZEWztPQMcRaLmCpVew8xKewd4LmFia2GiC3zdqvTuTvCwJbwjsfoqCRMQa5rpOBmkFyhmqnLxAusgmJyhzhRrpKpscYZIrLJHussk+Kesm0gaessngFFrEEd7QOYUeUXnB1insvnrEg7VxCod/4cY6m2YbPyGSHk/yXgPR+0BEb+sQvUNB9I4b0RskRH9Ekf3h12ZTsH6rDwIHENrviJrfAAAAAElFTkSuQmCC);
  background-size: 100% auto;
}
.overall-im {
  position: relative;
  width: ptrd(100px);
  margin: ptrd(20px) auto 0;
  img {
    width: 100%;
  }
}
.overall-im-tips {
  font-size: ptrd(24px);
  font-weight: bold;
  line-height: ptrd(28px);
  padding: ptrd(20px) ptrd(30px);
  background: #fff;
  position: absolute;
  right: ptrd(110px);
  white-space: nowrap;
  top: 50%;
  margin-top: ptrd(-34px);
  color: #111e36;
  border-radius: ptrd(8px);
  transform: scale(0);
  transition: 0.4s;
  transform-origin: right center;
  &.active {
    transform: scale(1);
  }
  &:after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -4px;
    content: "";
    @include arrow(right, 16px, #fff);
  }
}
.overall-card {
  position: absolute;
  bottom: 0;
  right: 0;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.6);
  padding: ptrd(20);
  border-radius: ptrd(16px);
  box-sizing: border-box;
  opacity: 0;
  transform: scale(0);
  transform-origin: right bottom;
  transition: 0.6s;
  &-close {
    position: absolute;
    right: ptrd(-18px);
    top: ptrd(-12px);
    z-index: 2;
    padding: ptrd(12px);
    em {
      display: block;
      width: ptrd(24px);
      height: ptrd(24px);
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABWklEQVRYR82XMW7DMAxFP4eiZ0l7hkyZigxFT9Gpp8mUUwQZik6ZcofkLEUHFgIUQHEsmp92HHk1+fVESl+SoJFPGuFAmyCqugSwzVX6EpHDlBVT1RWATdb8FJHjRf+qIqp6ArDIP38BfIjIzxQwqvoGYAfgOeudReTFA5JiJoHpgUjaJxF5rYGk0n0X1KNhKhBpguuy9TeL1Uik28Ro9e4aRqC2fliN6vZlhUqgSK7pIxHBSE6axKChMcJMbLelgyApwTOAJ8byIxfIEEweoDQretu7QQyYvwzyVMyYNkIKxIApq05DuBZrX1/zetgDKKuQQlN13iPnE12RoiqPBansjnlbU4GYd7FaPjHb9vWYlSdmlKExAzCxlMVHhCM5po9EBYeOg5rHtHsxGlOJbt8Zre5zoo3Lc+ddQx/l5P3V/a4JnaIEjPmuaePJaTnfvf+FrgH3gGoG5B9eJR4y+Jv+LAAAAABJRU5ErkJggg==)
      no-repeat center center;
      background-size: 100%;
    }
  }
  &-info {
    display: flex;
    align-items: center;
    padding-right: ptrd(30px);
    position: relative;
  }
  &-pic {
    width: ptrd(56px);
    height: ptrd(56px);
    border: 1px solid #ffffff;
    overflow: hidden;
    line-height: ptrd(56px);
    font-size: 0;
    border-radius: ptrd(56px);
    img {
      width: 100%;
    }
  }
  &-name {
    font-size: ptrd(30px);
    color: #ffffff;
    font-weight: bold;
    margin-left: ptrd(12px);
    line-height: ptrd(34px);
  }
  &-role {
    font-size: ptrd(22px);
    color: rgba(#ffffff, 0.8);
    margin-left: ptrd(16px);
    line-height: ptrd(26px);
  }
  .overall-btn_orange {
    background: #ff6600;

    &:active {
      background: #f16000;
    }
  }

  h3 {
    font-size: 0;
    line-height: ptrd(38px);
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: ptrd(32px);
      color: rgba(#ffffff, 1);
      margin-right: ptrd(16px);
      font-weight: bold;
      max-width: ptrd(162px);
      overflow: hidden;
      vertical-align: middle;
    }
    i {
      display: inline-block;
      vertical-align: middle;
      font-size: ptrd(22px);
      color: rgba(#ffffff, 0.8);
    }
  }
  &-portrait {
    display: inline-block;
    width: ptrd(56px);
    height: ptrd(56px);
    line-height: ptrd(56px);
    border-radius: ptrd(56px);
    border: 1px solid #ffffff;
    background: #fff;
    box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    margin-right: ptrd(12px);
    img {
      display: inline-block;
      vertical-align: middle;
      width: 100%;
    }
  }
}
.overall-card-btns {
  margin-top: ptrd(10px);
  display: flex;
  justify-content: space-between;
  a {
    flex: 1;
    height: ptrd(54);
    line-height: ptrd(54);
    background-image: linear-gradient(270deg, #206cfe 0%, #4c88ff 99%);
    border-radius: ptrd(4px);
    color: #fff;
    text-align: center;
    font-size: 0;
    &:active {
      background: #0044dd;
    }
    &:first-child:last-child {
      width: 100%;
    }
    & + a {
      margin-left: ptrd(20px);
    }
  }
  em {
    display: inline-block;
    width: ptrd(24);
    height: ptrd(24);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: ptrd(24px);
    vertical-align: middle;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    font-size: ptrd(22px);
    margin-left: ptrd(8px);
  }
}
.overall-card-tel {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACZElEQVRIS7WVW4hNYRiGn3ccaySEkmOUjJJGLkxJuTGhMOVq4lJEhDQXKEqUNJKQuZVDmUgTwo3cMEzJoRxCYUxu3MipDD59+n4ta3Z777XLX6tWa63/ff73Oy3xn5eSvpltBLYAM4H0/DtwH9gu6U4tZ/kjFOLHywh8AuZIelMUkgDP4+RbgWOSfgZ4BHAeWArskNReK+AbMByol/Q1K2JmmxwKnJDk94VWcvAamApMy4fBzNYCp4DTkvy+0EoAT+ACoElSd87BSuAS0CXJ7wutBLgItACrJV3IAZqBa8BVScsLqadyNLM9wN5ScTazfcBu4IikbbUCGqPeeyVNyfTGfOA2UAcszIevGli20XqBSUCjpAdRpvuBncA5Sa3VCOa/yQKOApuBM5LWBGARcAv4DDRIelcUkgX46V8Aw8LFw4B0evKBHmCxpC9FIH8BIXbIOxa4Icmrx8fIGOAeMANwqLt7BXjC3fE4wKFPgSeAh7dT0nvfnwe42EtgNLBL0oGATAeuALOAH4BvnhxO+oEhOVcfgWZJd/8BhJjPncsBXyWpK56PBLxkfVwMCjfrJPWY2VhgdlzeT0uAbklNAwAh5mHycLn11gSJd6P89JIel8qFmdVHUfRLGloSEEIngfWeBm+0FK5qEmxmvgf5KrfBzNzJwWi060CbpEeVIFUDwskyn6SR+F/AWaA9NWMeZmaDAU+8Saor6yAzMry6vKM9wf7f8PXWJyxwE+iLyvoQYT0MPJPUUBUgA/LSbIvJO7FCqDZI6igEyAqa2TxgBTAXmBDXeMB/Xj55OwY0WqXk1fL+NzmC6Bm0J7duAAAAAElFTkSuQmCC);
}
.overall-card-chat {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABIUlEQVRIS+2Vv07CMRSFv7PL4qaRJyDR0dW4+Qiyik4uMPAQTi7GxDAaeAQSQoyjK4M+gBrYXGRi8JqSlpAf8semTRzs2vR8597enorMS5n1mQHMbA+4Ao6AnUjwCHgEmpLencYU4MUHwHakcPHYB3DgIAHQBk6BLnAR6L+FeaN3wAnQkVQNgKFvSzlWPJjxkDdgJGk3AGzaLynJpZvZTO8f8OMc/J0WBSfrxrU4HBtXkB2wzvmy/Y0riAGY2RbwCYwllZK/AzM7BJ6AF0mVHACXRefAtaR6UoCZHQN9F9DAvqTnZAAvfu9D80bS5fx/EBV2/kIrwBlQ8//Lg4trSZMFQMzUzJ35Am6BRhBPARgDr0APaLmeF00myf9VlWcHfAPnY7EZU3g0pAAAAABJRU5ErkJggg==);
}
.overall-adviser {
  position: fixed;
  right: ptrd(30px);
  bottom: ptrd(300px);
  /* iOS 11.0 */
  padding-bottom: constant(safe-area-inset-bottom);
  /* iOS 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  &.active {
    .overall-adviser-portrait {
      opacity: 0;
      transition-delay: 0.2s;
    }
    .overall-card {
      transform: scale(1);
      opacity: 1;
    }
  }
  // @keyframes scaleOut {
  //   0% {
  //     opacity: 1;
  //     transform:scale(1);
  //   }
  //   5%{
  //     opacity: 1;
  //     transform:scale(0.75);
  //   }
  //   95%{
  //     opacity: 1;
  //     transform:scale(0.75);
  //   }
  //   100% {
  //     z-index: -1;
  //     opacity: 0;
  //     transform:scale(0.75);
  //   }
  // }
  // @keyframes scaleIn {
  //   0% {
  //     opacity: 0;
  //     z-index: -1;
  //   }
  //   5%{
  //     opacity: 1;
  //     z-index: 3;
  //     transform:scale(0.75);
  //   }
  //   100% {
  //       transform:scale(1)
  //   }
  // }
  // @keyframes moveIn {
  //   0% {
  //     opacity: 0;
  //     transform:translateX(100%)
  //   }
  //   100% {
  //     opacity: 1;
  //     transform:translateX(0)
  //   }
  // }
  // @keyframes moveOut {
  //   0% {
  //     opacity: 1;
  //     transform:translateX(0)
  //   }
  //   100% {
  //     opacity: 0;
  //     transform:translateX(100%)
  //   }
  // }
  // &.open{
  //   .overall-adviser-portrait{
  //     animation-name: scaleOut;
  //     animation-duration: 0.3s;
  //     animation-fill-mode:forwards;
  //   }
  //   .overall-adviser-tag{
  //     opacity: 0;
  //   }
  //   .overall-card{
  //     animation-name: moveIn;
  //     animation-duration: 1s;
  //     animation-delay:0.18s;
  //   }
  // }
  // &.close{
  //   .overall-adviser-portrait{
  //       animation-name: scaleIn;
  //       animation-duration: .4s;
  //       animation-fill-mode: backwards;
  //     }
  //   .overall-adviser-tag{
  //     opacity: 1;
  //   }
  //   .overall-card{
  //     animation-name: moveOut;
  //     animation-duration: 1s;
  //   //  animation-delay:0.68s;
  //     animation-fill-mode: forwards;
  //   }
  // }
}
.overall-adviser-portrait {
  display: block;
  position: relative;
  width: ptrd(80px);
  margin-left: auto;
  z-index: 3;
  transform-origin: center center;
  transition: 0.4s;
  opacity: 1;
}

.overall-adviser-warn {
  position: absolute;
  right: 0;
  top: 0;
  width: 8px;
  height: 8px;
  border: 1px solid #fff;
  border-radius: 100%;
  z-index: 1;
  &.red {
    background: #fe4a3b;
  }
  &.green {
    background: #00cc88;
  }
}
.overall-adviser-pic {
  background: #fff;
  width: ptrd(80px);
  height: ptrd(80px);
  border-radius: 100%;
  overflow: hidden;
  border: 1px solid #fff;
  box-sizing: border-box;
  img {
    width: 100%;
  }
}
.overall-adviser-tag {
  position: absolute;
  font-size: ptrd(24px);
  color: #fff;
  font-weight: bold;
  height: ptrd(38px);
  line-height: ptrd(38px);
  background: #0055ff;
  border-radius: ptrd(38px);
  padding: 0 ptrd(8px);
  white-space: nowrap;
  transform-origin: center center;
  left: 50%;
  transform: translate(-50%, ptrd(-20px)) scale(0.68);
  opacity: 1;
  transition: opacity 0.6s;
  // &.disapeared {
  //   opacity: 0;
  // }
}
</style>
